import { AbstractPmsApiService } from "./abstract.service";

/**
 * @abstract
 * @extends {AbstractPmsApiService>}
 */
export class ChannelMappingPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/channel-mapping';
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<Object>}
     */
    access(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<Object>}
     */
    list(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url + '/list', {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/channel-mapping.service.js